import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./css/main.css";
import "./css/tablet.css";
import "./css/mobile.css";
import "./css/special.css";
import i18n from "./i18n";
import { DataContextProvider } from "./dataContext";
import { useSelector } from "react-redux";
import AnimatedRoutes from "./router";

const App = () => {
  return (
    <HelmetProvider>
      <DataContextProvider>
        <Router>
          <AnimatedRoutes />
        </Router>
      </DataContextProvider>
    </HelmetProvider>
  );
};

export default App;
